import { useMemo, useState } from 'react';
import Select from '../../components/Select/Select';
import { BANKS, DEAL_STEPS } from '../../constants';
import { ROLE_ADMIN } from '../../constants/roles';
import { textStyles } from '../../constants/textStyles';
import Button from '../../components/Button/Button';
import setStep from '../../api/deals/setStep';
import isUserHaveRole from '../../utils/isUserHaveRole';

const DealConfigureSteps = ({bankId, dealId, update}) => {
    const [statudId, setStatusId] = useState(null);

    const options = useMemo(() => {
        
        const bankKeys = Object.keys(BANKS);
        let bankName;

        for(let i of bankKeys) {
            if(BANKS?.[i] == bankId) {
                bankName = i;
            }
        }

        console.log("BANKID", bankId, bankName, DEAL_STEPS?.[bankName]);

        
        const otherOptions = [
            {
                label: "ÐÐ¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ",
                value: 2,
            },
            {
                label: "ÐÐ¾Ð¿.ÑÑÐ»ÑÐ³Ð¸",
                value: 3,
            },
            {
                label: "Ð£ÑÐ¾ÑÐ½ÐµÐ½Ð¸Ðµ Ð´Ð°Ð½Ð½ÑÑ",
                value: 5,
            },
            {
                label: "ÐÑÐ±Ð¾Ñ ÐÐ°Ð½ÐºÐ°",
                value: 5,
            },
            {
                label: "Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ",
                value: DEAL_STEPS.TRIPARTITE_CONTRACT,
            },
            {
                label: "Ð¤Ð¸Ð½Ð°Ð»",
                value: 10,
            },
        ]

        if(!bankId || !bankName || !DEAL_STEPS?.[bankName]) return otherOptions;

        const keys = Object.keys(DEAL_STEPS?.[bankName]);

        const newOptions = keys?.map((key) => {
            return {
                label: key,
                value: DEAL_STEPS?.[bankName]?.[key]
            }
        });


        return [...otherOptions, ...newOptions];
    }, [bankId])
    
    // if(!bankId || !options) {
    //     return null;
    // }

    const submit = () => {
        // update Ð¼Ð¾Ð¶ÐµÑ Ð½Ðµ Ð¿ÑÐ¸Ð¹ÑÐ¸: Ð½Ð° ÑÐ°Ð¼Ð¾ÑÑÐ¾ÑÑÐµÐ»ÑÐ½Ð¾Ð¼ ÑÐ¾ÑÑÐµ /deals/deal/:id/credit
        // DealCredits ÑÐµÐ½Ð´ÐµÑÐ¸ÑÑÑ Ð±ÐµÐ· Ð¿ÑÐ¾Ð¿ÑÐ¾Ð², Ð¸ ÑÑÐ°Ð¿ ÑÐ¾ÑÑÐ°Ð½ÑÐ»ÑÑ Ð±Ñ, Ð° ÑÑÑÐ°Ð½Ð¸ÑÐ°
        // Ð¿Ð°Ð´Ð°Ð»Ð° Ð½Ð° update() Ð¸ Ð¾ÑÑÐ°Ð²Ð°Ð»Ð°ÑÑ ÑÐ¾ ÑÑÐ°ÑÑÐ¼ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸ÐµÐ¼.
        setStep({ dealId, step: statudId }).then(() => {
            update && update();
        });
    };

    if (!isUserHaveRole(ROLE_ADMIN)) {
        return;
    }

    return(<div>
        <p style={{ ...textStyles.formTitle, marginBottom: 20, marginTop: 40 }}>Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÑÑÐ°Ð¿Ð° ÑÐ´ÐµÐ»ÐºÐ¸:</p>

        <div style={{marginBottom: 20}}>
            <Select onChange={(option) => setStatusId(option?.value)} label="Ð­ÑÐ°Ð¿ ÑÐ´ÐµÐ»ÐºÐ¸" options={options} />
        </div>
        <Button onClick={submit} fill disabled={!statudId}>Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ</Button>
    </div>)
}

export default DealConfigureSteps;